import { environment } from '../../../environments/environment';
import {
  DEFAULT_TENANT_ID,
  getDefaultTenantConfig,
  getTenantConfigById,
  getTenantConfigForHost,
  type TenantConfig
} from './tenant-registry';

type RuntimeTenantConfig = {
  id?: string;
  host?: string;
};

type RuntimeAppConfig = {
  tenant?: RuntimeTenantConfig;
};

declare global {
  interface Window {
    __PPS_CONFIG__?: RuntimeAppConfig;
  }
}

export function resolveTenantId(): string {
  const runtimeConfig = typeof window !== 'undefined' ? window.__PPS_CONFIG__ : undefined;

  const runtimeTenant = getTenantConfigById(runtimeConfig?.tenant?.id);
  if (runtimeTenant) {
    return runtimeTenant.id;
  }

  const envTenant = getTenantConfigById((environment as any)?.tenant?.id);
  if (envTenant) {
    return envTenant.id;
  }

  const runtimeHost = runtimeConfig?.tenant?.host;
  const windowHost = typeof window !== 'undefined' ? window.location.hostname : undefined;
  const hostTenant = getTenantConfigForHost(runtimeHost ?? windowHost);
  if (hostTenant) {
    return hostTenant.id;
  }

  return DEFAULT_TENANT_ID;
}

export function getTenantConfig(): TenantConfig {
  return getTenantConfigById(resolveTenantId()) ?? getDefaultTenantConfig();
}

export function tenantStorageKey(baseKey: string): string {
  return `${resolveTenantId()}_${baseKey}`;
}

export function legacyPhmStorageKey(baseKey: string): string {
  return `phm_${baseKey}`;
}

export function getTenantStorage(baseKey: string): string | null {
  const value = localStorage.getItem(tenantStorageKey(baseKey));
  if (value !== null) {
    return value;
  }
  return localStorage.getItem(legacyPhmStorageKey(baseKey));
}

export function setTenantStorage(baseKey: string, value: string): void {
  localStorage.setItem(tenantStorageKey(baseKey), value);
}

export function removeTenantStorage(baseKey: string): void {
  localStorage.removeItem(tenantStorageKey(baseKey));
  localStorage.removeItem(legacyPhmStorageKey(baseKey));
}
